import { bool, date, object, string, number, array, mixed } from "yup";

export const userSchema = object({
    firstName: string().required("First name is required"),
    lastName: string().required("Last name is required"),
    email: string().required("Email is required"),
    role: string().required().oneOf(["admin", "user"]),
    isEmailVerified: bool().required(),
    loginMethod: string().oneOf(["email", "google", undefined]),
    stripeCustomerId: string(),
    credits: object({
        balance: number().required(),
        lastUpdated: date().required(),
    }),
    accountDeletionRequestedAt: date().nullable(),
    scheduledDeletionDate: date().nullable(),
    createdAt: date().required(),
    flags: mixed(),
    marketingOptIns: array(
        object({
            channel: string().required(),
            optedIn: bool().required(),
            timestamp: date().required(),
            source: string().required(),
        }),
    ),
    preferences: object({
        industries: array(string()).required(),
        experienceLevel: string(),
        jobTypes: array(string()).required(),
        jobRoles: array(string()).required(),
    }),
    acceptedTerms: bool().required(),
    lastLoginAt: date().nullable(),
});
